<template>
	<div class="min-h-screen bg-gray-100">
		<div class="max-w-3xl mx-auto bg-white shadow-md rounded-lg p-6 sm:p-8">
			<div class="max-w-4xl mx-auto">
				<h1 class="text-2xl font-bold text-center mb-8">{{ APP_DISPLAY_NAME }}第三方SDK目录</h1>

				<p class="text-gray-700 leading-relaxed mb-10">
					为保障{{ APP_DISPLAY_NAME }}服务的相关功能实现与安全稳定的运行，我们可能会接入由第三方提供的软件开发包（SDK）或类似应用程序实现相关目的。我们会对合作方获取信息的软件工具开发包（SDK）或类似应用程序进行安全评估，以保护您的个人信息安全。以下是我们接入的主要的第三方服务商信息：
				</p>

				<section>
					<h2 class="text-xl font-semibold mb-6">第三方SDK列表</h2>

					<div class="space-y-10">
						<!-- 微信SDK -->
						<div>
							<h3 class="text-lg font-semibold mb-3">微信OpenSDK Android</h3>
							<div class="text-sm space-y-3">
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">第三方机构名称：</span>
									<span class="md:col-span-3">深圳市腾讯计算机系统有限公司</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">收集个人信息类型：</span>
									<span class="md:col-span-3">
										Android ID、OAID、SSID、BSSID；系统设置、系统属性、设备型号、设备品牌、操作系统；获取应用安装列表、正在运行的应用列表；IP
										地址、网络类型、运营商信息、Wi-Fi状态、Wi-Fi参数、Wi-Fi列表
									</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">使用目的：</span>
									<span class="md:col-span-3">满足用户使用微信快速登录，分享截图、内容给好友，判断是否安装微信；微信支付功能</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">第三方隐私政策：</span>
									<a
										href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8"
										class="text-blue-600 hover:underline break-all md:col-span-3"
										target="_blank"
										rel="noopener noreferrer"
									>
										https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8
									</a>
								</div>
							</div>
						</div>

						<!-- 支付宝支付SDK -->
						<div>
							<h3 class="text-lg font-semibold mb-3">App支付客户端SDK</h3>
							<div class="text-sm space-y-3">
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">第三方机构名称：</span>
									<span class="md:col-span-3">支付宝(杭州)信息技术有限公司</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">收集个人信息类型：</span>
									<span class="md:col-span-3">AndroidID、OAID、IDFV、传感器信息（传感器列表）、设备屏幕密度、运营商信息、WIFI参数、网络类型</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">使用目的：</span>
									<span class="md:col-span-3">
										保障用户账户和资金安全以及支付服务的安全稳定运行；履行反洗钱、反恐怖融资、反电信网络诈骗等法定义务；实现网络链路的选择和优化，以提升用户体验。
									</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">第三方隐私政策：</span>
									<a
										href="https://opendocs.alipay.com/open/54/01g6qm"
										class="text-blue-600 hover:underline break-all md:col-span-3"
										target="_blank"
										rel="noopener noreferrer"
									>
										https://opendocs.alipay.com/open/54/01g6qm
									</a>
								</div>
							</div>
						</div>

						<!-- HTTPDNS-android -->
						<div>
							<h3 class="text-lg font-semibold mb-3">HTTPDNS-android</h3>
							<div class="text-sm space-y-3">
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">第三方机构名称：</span>
									<span class="md:col-span-3">杭州阿里云智能科技有限公司</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">收集个人信息类型：</span>
									<span class="md:col-span-3">
										Android ID、OAID、SSID、BSSID；系统设置、系统属性、设备型号、设备品牌、操作系统；获取应用安装列表、正在运行的应用列表；IP
										地址、网络类型、运营商信息、Wi-Fi状态、Wi-Fi参数、Wi-Fi列表；读取/写入文件，读写存储空间
									</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">使用目的：</span>
									<span class="md:col-span-3">云存储、消息推送、DNS解析等服务</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">第三方隐私政策：</span>
									<a
										href="https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112071754_83380.html?spm=a2c4g.11186623.0.0.598730e5wsglWa"
										class="text-blue-600 hover:underline break-all md:col-span-3"
										target="_blank"
										rel="noopener noreferrer"
									>
										https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112071754_83380.html?spm=a2c4g.11186623.0.0.598730e5wsglWa
									</a>
								</div>
							</div>
						</div>

						<!-- 腾讯Bugly SDK -->
						<div>
							<h3 class="text-lg font-semibold mb-3">Bugly Android</h3>
							<div class="text-sm space-y-3">
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">第三方机构名称：</span>
									<span class="md:col-span-3">深圳市腾讯计算机系统有限公司</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">收集个人信息类型：</span>
									<span class="md:col-span-3">
										设备MAC地址、设备标识及硬件序列号 (ICCID、IDFV、OAID、IMEI、MEID、IMSI、Android
										ID)、手机型号、手机品牌、Android系统版本、Android系统API等级、厂商系统版本、cpu架构类型、设备是否root、磁盘空间占用大小、sdcardk空间占用大小、内存空间占用大小、网络类型、应用当前正在运行的进程名和PID
									</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">使用目的：</span>
									<span class="md:col-span-3">收集APP崩溃、闪退等异常信息</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">第三方隐私政策：</span>
									<a
										href="https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56"
										class="text-blue-600 hover:underline break-all md:col-span-3"
										target="_blank"
										rel="noopener noreferrer"
									>
										https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56
									</a>
								</div>
							</div>
						</div>

						<!-- 中国电信 SDK -->
						<div>
							<h3 class="text-lg font-semibold mb-3">中国电信SDK</h3>
							<div class="text-sm space-y-3">
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">第三方机构名称：</span>
									<span class="md:col-span-3">中国电信集团有限公司</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">收集个人信息类型：</span>
									<span class="md:col-span-3">IP 地址、IMSI、MAC 地址、IMEI、OAID、sim 卡信息，手机机型、系统类型、系统版本、运营商、网络类型、网络环境、网管取号报错日志</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">使用目的：</span>
									<span class="md:col-span-3">电信手机号码一键登录</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">第三方隐私政策：</span>
									<a href="https://www.189.cn/tj/sy_ycgg/100506.html" class="text-blue-600 hover:underline break-all md:col-span-3" target="_blank" rel="noopener noreferrer">
										https://www.189.cn/tj/sy_ycgg/100506.html
									</a>
								</div>
							</div>
						</div>

						<!-- 腾讯 X5 浏览器 SDK -->
						<div>
							<h3 class="text-lg font-semibold mb-3">腾讯X5浏览器SDK</h3>
							<div class="text-sm space-y-3">
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">第三方机构名称：</span>
									<span class="md:col-span-3">深圳市腾讯计算机系统有限公司</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">收集个人信息类型：</span>
									<span class="md:col-span-3">设备序列号、设备信息、应用信息、网络信息；设备标识符（IMEI、IDFA、AndroidID、MAC、OAID相关信息），设备型号，操作系统</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">使用目的：</span>
									<span class="md:col-span-3">支持网页在线编辑内容</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">第三方隐私政策：</span>
									<a
										href="https://privacy.qq.com/policy/tencent-privacypolicy"
										class="text-blue-600 hover:underline break-all md:col-span-3"
										target="_blank"
										rel="noopener noreferrer"
									>
										https://privacy.qq.com/policy/tencent-privacypolicy
									</a>
								</div>
							</div>
						</div>

						<!-- 设备唯一标识符 SDK -->
						<div>
							<h3 class="text-lg font-semibold mb-3">设备唯一标识符SDK</h3>
							<div class="text-sm space-y-3">
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">第三方机构名称：</span>
									<span class="md:col-span-3">中国信息通信研究院</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">收集个人信息类型：</span>
									<span class="md:col-span-3">Android：设备信息（OAID）、设备序列号</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">使用目的：</span>
									<span class="md:col-span-3">获取OAID替代IMEI，用于用户统计、用户行为反作弊</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">第三方隐私政策：</span>
									<a href="http://www.msa-alliance.cn/col.jsp?id=122" class="text-blue-600 hover:underline break-all md:col-span-3" target="_blank" rel="noopener noreferrer">
										http://www.msa-alliance.cn/col.jsp?id=122
									</a>
								</div>
							</div>
						</div>

						<!-- 巨量引擎转化 SDK -->
						<div>
							<h3 class="text-lg font-semibold mb-3">巨量引擎转化SDK</h3>
							<div class="text-sm space-y-3">
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">第三方机构名称：</span>
									<span class="md:col-span-3">北京字节跳动科技有限公司</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">收集个人信息类型：</span>
									<span class="md:col-span-3">
										设备品牌、型号、操作系统、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、浏览器的类型和版本号、操作、使用、服务日志等基础信息、AndroidID、OAID、手机系统重启时间、磁盘总空间、系统总内存空间、CPU数目等基础信息、IDFV、WiFi路由器MAC地址（BSSID）、设备的MAC地址、设备标识符（如IMEI、IMSI、ICCID、GAID（仅GMS服务）、MEID、设备序列号build_serial，IDFA）；应用信息（开发者应用名、应用包名、运行中的进程信息、版本号、应用前后台状态、WIFI状态、软件列表信息）；广告信息（对广告的展示、点击及转化等交互数据）；位置信息、性能数据（崩溃数据、性能数据）；运营商信息、设备时区、sim卡信息
									</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">使用目的：</span>
									<span class="md:col-span-3">转化跟踪，保障软件与服务的安全运行以及优化产品体验</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">第三方隐私政策：</span>
									<a
										href="https://bytedance.larkoffice.com/docx/NtbVd73CIoFLsuxqsyPcjHrdnFB"
										class="text-blue-600 hover:underline break-all md:col-span-3"
										target="_blank"
										rel="noopener noreferrer"
									>
										https://bytedance.larkoffice.com/docx/NtbVd73CIoFLsuxqsyPcjHrdnFB
									</a>
								</div>
							</div>
						</div>

						<!-- 移动一键登录 SDK -->
						<div>
							<h3 class="text-lg font-semibold mb-3">移动一键登录SDK</h3>
							<div class="text-sm space-y-3">
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">第三方机构名称：</span>
									<span class="md:col-span-3">中国移动通信集团有限公司</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">收集个人信息类型：</span>
									<span class="md:col-span-3">IP 地址、IMSI、MAC 地址、IMEI、OAID、sim 卡信息，手机机型、系统类型、运营商、网络类型、系统版本、网络环境、网管取号报错日志</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">使用目的：</span>
									<span class="md:col-span-3">一键登录</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">第三方隐私政策：</span>
									<a
										href="https://wap.cmpassport.com/resources/html/contract.html"
										class="text-blue-600 hover:underline break-all md:col-span-3"
										target="_blank"
										rel="noopener noreferrer"
									>
										https://wap.cmpassport.com/resources/html/contract.html
									</a>
								</div>
							</div>
						</div>

						<!-- 联通一键登录 SDK -->
						<div>
							<h3 class="text-lg font-semibold mb-3">联通一键登录SDK</h3>
							<div class="text-sm space-y-3">
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">第三方机构名称：</span>
									<span class="md:col-span-3">中国联合网络通信集团有限公司</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">收集个人信息类型：</span>
									<span class="md:col-span-3">IP 地址、IMSI、MAC 地址、IMEI、OAID、sim卡信息，手机机型、系统类型、系统版本、运营商、网络类型、网络环境、网管取号报错日志</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">使用目的：</span>
									<span class="md:col-span-3">一键登录</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">第三方隐私政策：</span>
									<a
										href="https://img.client.10010.com/stprototype/clientonekeylogin/onekeyloginyinsi.html"
										class="text-blue-600 hover:underline break-all md:col-span-3"
										target="_blank"
										rel="noopener noreferrer"
									>
										https://img.client.10010.com/stprototype/clientonekeylogin/onekeyloginyinsi.html
									</a>
								</div>
							</div>
						</div>

						<!-- 360奇虎 SDK -->
						<div>
							<h3 class="text-lg font-semibold mb-3">360奇虎SDK</h3>
							<div class="text-sm space-y-3">
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">第三方机构名称：</span>
									<span class="md:col-span-3">北京奇虎科技有限公司</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">收集个人信息类型：</span>
									<span class="md:col-span-3">MAC 地址、IMEI、OAID、Android ID</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">使用目的：</span>
									<span class="md:col-span-3">app安装包的加固</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">第三方隐私政策：</span>
									<a href="https://jiagu.360.cn/#/global/index" class="text-blue-600 hover:underline break-all md:col-span-3" target="_blank" rel="noopener noreferrer">
										https://jiagu.360.cn/#/global/index
									</a>
								</div>
							</div>
						</div>

						<!-- 七牛 SDK -->
						<div>
							<h3 class="text-lg font-semibold mb-3">七牛 SDK</h3>
							<div class="text-sm space-y-3">
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">第三方机构名称：</span>
									<span class="md:col-span-3">上海七牛信息技术有限公司</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">收集个人信息类型：</span>
									<span class="md:col-span-3">厂商、机型、系统版本、厂商、机型、系统版本</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">使用目的：</span>
									<span class="md:col-span-3">上传头像</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">第三方隐私政策：</span>
									<a
										href="https://developer.qiniu.io/kodo/11868/the-sdk-privacy-policy"
										class="text-blue-600 hover:underline break-all md:col-span-3"
										target="_blank"
										rel="noopener noreferrer"
									>
										https://developer.qiniu.io/kodo/11868/the-sdk-privacy-policy
									</a>
								</div>
							</div>
						</div>

						<!-- 微博移动SDK-android -->
						<div>
							<h3 class="text-lg font-semibold mb-3">微博移动SDK-android</h3>
							<div class="text-sm space-y-3">
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">第三方机构名称：</span>
									<span class="md:col-span-3">北京微梦创科网络技术有限公司</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">收集个人信息类型：</span>
									<span class="md:col-span-3">设备型号、用户分享时，获取用户选择的图片或视频</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">使用目的：</span>
									<span class="md:col-span-3">用于实现微博分享功能</span>
								</div>
								<div class="grid grid-cols-1 md:grid-cols-4 gap-2">
									<span class="font-medium md:col-span-1">第三方隐私政策：</span>
									<a
										href="https://open.weibo.com/wiki/Sdk/privacy"
										class="text-blue-600 hover:underline break-all md:col-span-3"
										target="_blank"
										rel="noopener noreferrer"
									>
										https://open.weibo.com/wiki/Sdk/privacy
									</a>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { APP_DISPLAY_NAME } from '@/config/app'
</script>
